import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type UpdateLocationFavoriteMutationVariables = Types.Exact<{
  id: Types.Scalars['bigint']['input'];
  fav: Types.Scalars['Boolean']['input'];
}>;


export type UpdateLocationFavoriteMutation = { __typename?: 'mutation_root', update_locations?: { __typename?: 'locations_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'locations', id: number, name?: string | null, favorite: boolean }> } | null };


export const UpdateLocationFavoriteDocument = gql`
    mutation updateLocationFavorite($id: bigint!, $fav: Boolean!) {
  update_locations(where: {id: {_eq: $id}}, _set: {favorite: $fav}) {
    affected_rows
    returning {
      id
      name
      favorite
    }
  }
}
    `;
export type UpdateLocationFavoriteMutationFn = Apollo.MutationFunction<UpdateLocationFavoriteMutation, UpdateLocationFavoriteMutationVariables>;

/**
 * __useUpdateLocationFavoriteMutation__
 *
 * To run a mutation, you first call `useUpdateLocationFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationFavoriteMutation, { data, loading, error }] = useUpdateLocationFavoriteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fav: // value for 'fav'
 *   },
 * });
 */
export function useUpdateLocationFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationFavoriteMutation, UpdateLocationFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationFavoriteMutation, UpdateLocationFavoriteMutationVariables>(UpdateLocationFavoriteDocument, options);
      }
export type UpdateLocationFavoriteMutationHookResult = ReturnType<typeof useUpdateLocationFavoriteMutation>;
export type UpdateLocationFavoriteMutationResult = Apollo.MutationResult<UpdateLocationFavoriteMutation>;
export type UpdateLocationFavoriteMutationOptions = Apollo.BaseMutationOptions<UpdateLocationFavoriteMutation, UpdateLocationFavoriteMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/locations/queries/updateLocationFavorite.mutation.gql}
 */
export async function updateLocationFavorite(
  variables: UpdateLocationFavoriteMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateLocationFavoriteMutation['update_locations']>
export async function updateLocationFavorite(
  variables: UpdateLocationFavoriteMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateLocationFavoriteMutation>
export async function updateLocationFavorite(
  variables: UpdateLocationFavoriteMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateLocationFavoriteMutation['update_locations'] | UpdateLocationFavoriteMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateLocationFavoriteMutation>(
    UpdateLocationFavoriteDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_locations
}